import { render, staticRenderFns } from "./DuplicateLesson.vue?vue&type=template&id=0e807c2c&lang=pug&"
import script from "./DuplicateLesson.vue?vue&type=script&lang=js&"
export * from "./DuplicateLesson.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateLesson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports